export enum OperationType {
  CREATED = "CREATED",
  RE_DO = "RE_DO",
  INHERITS = "INHERITS",
  CORRECTED_AS_FAST_OF_PRODUCTION = "CORRECTED_AS_FAST_OF_PRODUCTION",
  CORRECTED_AS_ORDER_INSTRUCTION = "CORRECTED_AS_ORDER_INSTRUCTION",
  NOT_TO_INVOICE = "NOT_TO_INVOICE",
}
